import iconConfigArea from "../assets/icon-config_area.svg";
import iconConfigPosition from "../assets/icon-config_position.svg";
import iconConfigCostCenter from "../assets/icon-config_costCenter.svg";
import iconConfigProjectStatus from "../assets/icon-config_projectStatus.svg";
import iconConfigSync from "../assets/icon-config_sync.svg";
import iconConfigToken from "../assets/icon-config_token.svg";
import iconConfigCustomFields from "../assets/icon-config_customFields.svg";
import iconConfigPermission from "../assets/icon-config-permission.svg";
import iconConfigUser from "../assets/icon-config_users.svg";
import iconConfigAvailability from "../assets/icon-config-availability.svg";
import iconConfigHolidays from "../assets/icon-config-holidays.svg";
import iconConfigFinancial from "../assets/account-settings-svgrepo-com.svg";
import iconConfigAudit from "../assets/icon-config-audit.svg";
import { FeatureStatic } from "../@types/statics/feature.static";
type FeatureStaticKeys = keyof typeof FeatureStatic; 

export const getConfigurations = () : Array<{
    icon: string;
    name: string;
    path: string;
    featureKey: FeatureStaticKeys;
  }> => {
    return [
    {
      icon: iconConfigArea,
      name: "Áreas",
      path: "/configurations/areas",
      featureKey: "areas",
    },
    {
      icon: iconConfigPosition,
      name: "Funções",
      path: "/configurations/positions",
      featureKey: "positions",
    },
    {
      icon: iconConfigCostCenter,
      name: "Centro de Custo",
      path: "/configurations/costCenter",
      featureKey: "costCenter",
    },
    {
      icon: iconConfigProjectStatus,
      name: "Status de Projetos",
      path: "/configurations/projectstatus",
      featureKey: "projectStatus",
    },
    {
      icon: iconConfigSync,
      name: "Sincronização de Dados",
      path: "/configurations/synchronization",
      featureKey: "syncData",
    },
    {
      icon: iconConfigToken,
      name: "Tokens de API",
      path: "/configurations/tokens",
      featureKey: "apiTokens",
    },
    {
      icon: iconConfigPermission,
      name: "Permissões",
      path: "/configurations/permissions",
      featureKey: "permissions",
    },
    {
      icon: iconConfigUser,
      name: "Usuários",
      path: "/configurations/users",
      featureKey: "users",
    },
    {
      icon: iconConfigCustomFields,
      name: "Campos Personalizados",
      path: "/configurations/customFields",
      featureKey: "customFields",
    },
    {
      icon: iconConfigAvailability,
      name: "Disponibilidade Padrão",
      path: "/configurations/availabilities",
      featureKey: "availabilities",
    },
    {
      icon: iconConfigHolidays,
      name: "Feriados",
      path: "/configurations/holidays",
      featureKey: "holidays",
    },
    {
      icon: iconConfigFinancial,
      name: "Configuração da Conta",
      path: "/configurations/financial",
      featureKey: "accountConfiguration",
    },
    {
      icon: iconConfigAudit,
      name: "Auditoria",
      path: "/configurations/audit",
      featureKey: "audit",
    }
  ];
}